import { mutatorAction, mutator } from 'satcheljs';
import { getStore } from '../store/store';
import { toggleCalendarLeftPaneExpansion } from '../actions/toggleCalendarLeftPaneExpansion';

export const setIsLeftNavShown = mutatorAction('isLeftNavShown', (isLeftNavShown: boolean) => {
    getStore().isLeftNavShown = isLeftNavShown;
});

mutator(toggleCalendarLeftPaneExpansion, () => {
    const newLeftNavState = !getStore().isLeftNavShown;
    getStore().isLeftNavShown = newLeftNavState;
});
